import { BrowserRouter, Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';

import Login from '../components/authentication/Login';
import Pin from '../components/authentication/Pin';
import ForgotPin from '../components/authentication/ForgotPin';
import Role from '../components/home/Role';
import Dashboard from '../components/home/Dashboard';
import ServicesList from '../components/service/ServicesList';
import ProfileList from '../components/profile/ProfileList';
import ReceiveList from '../components/receive/ReceiveList';

import { useSelector, useDispatch } from "react-redux";
import { useEffect } from 'react';
import { resetUser } from '../redux/slice/user';
import { axiosInstance as axios, endpoint } from "../api/axios";

function NotFound() {
  return <Navigate to="/" replace />;
}

const AutoLogout = () => {
  const isLoggedIn = useSelector(state => state.user.isLoggedIn);
  const currentUserId = useSelector(state => state.user.currentUserId);
  const user = useSelector(state => state.user.users[state.user.currentUserId]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const excludedPaths = ['/', '/pin', '/role', '/forgot-pin'];

  useEffect(() => {
    const currentPath = location.pathname;

    if (isLoggedIn && currentUserId && !excludedPaths.includes(currentPath)) {
      const timer = setTimeout(async () => {
        try {
          if (user?.token) {
            await axios.post(
              endpoint.auth.logout,
              {},
              {
                headers: {
                  Authorization: `${user.token_type} ${user.token}`,
                },
              }
            );
          }
        } catch (err) {
          console.error('Logout API error:', err.message);
        }

        dispatch(resetUser({ id: currentUserId }));
        navigate('/');
      }, 3600000);

      return () => clearTimeout(timer);
    }
  }, [isLoggedIn, currentUserId, user, location.pathname, dispatch, navigate]);

  return (
    <Routes>
      <Route path="/" element={isLoggedIn ? <Navigate to="/pin" /> : <Login />} />
      <Route path="/pin" element={isLoggedIn ? <Pin /> : <Navigate to="/" />} />
      <Route path="/forgot-pin" element={isLoggedIn ? <ForgotPin /> : <Navigate to="/" />} />
      <Route path="/role" element={isLoggedIn ? <Role /> : <Navigate to="/" />} />
      <Route path="/dashboard" element={isLoggedIn ? <Dashboard /> : <Navigate to="/" />} />
      <Route path="/services" element={isLoggedIn ? <ServicesList /> : <Navigate to="/" />} />
      <Route path="/profile" element={isLoggedIn ? <ProfileList /> : <Navigate to="/" />} />
      <Route path="/receive" element={isLoggedIn ? <ReceiveList /> : <Navigate to="/" />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const Path = () => (
  <BrowserRouter>
    <AutoLogout />
  </BrowserRouter>
);

export default Path;
